/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
import {numberWithCommas, zip} from "../../../utils";


export function processResponse({
                                  adminYn, item, item2, areaNameAry, areaColAry,
                                  gubun_code, prm_check, prm_check2
                                }) {
  const resultAdminYn = adminYn;
  const resultItem = item;

  const chart1Data = zip(areaNameAry, areaColAry).map(([areaName, areaCol]) => ({
    AR_NAME: areaName,
    AR_COLUMN: areaCol,
    AR_AREA: 0,
    RDW_AREA: 0,
    RDS_AREA: null,
  }));
  const chart1Data2 = [];

  let totalRdsData = 0;

  for (let i = 0; i < resultItem.length; ++i) {
    const item = resultItem[i];
    const {DATA_COLUMN, DATA_FIELD, DATA_TYPE, DATA_SUM} = item;

    // eslint-disable-next-line default-case
    switch (DATA_TYPE) {
      case 'DATA_TYPE1' : // 용도지역별 면적
        if (DATA_COLUMN === 'AREA_TOTAL') continue;
        for (let j = 0; j < chart1Data.length; j++) {
          if (DATA_COLUMN === chart1Data[j]['AR_COLUMN']) {
            chart1Data[j]['AR_AREA'] = Number(Number(DATA_SUM).toFixed(2));
          }
        }
        break;

      case 'DATA_TYPE3' : // 용도지역별 무선국 수
        for (let j = 0; j < chart1Data.length; j++) {
          if (DATA_COLUMN === chart1Data[j]['AR_COLUMN']) {
            chart1Data[j]['RDW_AREA'] = DATA_SUM;
          }
        }
        break;

      case 'DATA_TYPE2' : // 인구유형별 서비스별 밀도
        const tmpData = {
          DATA_FIELD,
          DATA_COLUMN,
          DATA_SUM: Number(DATA_SUM).toFixed(2),
          DATA_SUM_str: numberWithCommas(Number(DATA_SUM).toFixed(2)),
        };

        for (let j = 0; j < chart1Data.length; j++) {
          if (DATA_COLUMN === chart1Data[j]['AR_COLUMN']) {
            chart1Data[j]['RDS_AREA'] = Number(DATA_SUM).toFixed(2);
          }
        }

        if (DATA_COLUMN === 'AREA_TOTAL') {
          if (DATA_SUM)
            totalRdsData = numberWithCommas(Number(DATA_SUM).toFixed(2));
        }

        if (gubun_code === "service") {
          // window.prm_check / window.prm_check2를 참조 : MapFusionCountry.js에서 설정
          for (let j = 0; j < prm_check.length; j++) {
            if (resultAdminYn === 'Y') {
              tmpData['DATA_' + prm_check[j] + '_LG'] =
                Number(item['DATA_' + prm_check[j] + '_LG']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_LG_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_LG']).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_KT'] =
                Number(item['DATA_' + prm_check[j] + '_KT']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_KT_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_KT']).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_SK'] =
                Number(item['DATA_' + prm_check[j] + '_SK']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_SK_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_SK']).toFixed(2));
            } else {
              tmpData['DATA_' + prm_check[j]] = Number(item['DATA_' + prm_check[j]]).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j]]).toFixed(2));
            }
          }
        } else if (gubun_code === 'cls') {
          for (let j = 0; j < prm_check2.length; j++) {
            tmpData['DATA_' + prm_check2[j]] = Number(item['DATA_' + prm_check2[j]]).toFixed(2);
            tmpData['DATA_' + prm_check2[j] + '_str'] =
              numberWithCommas(Number(item['DATA_' + prm_check2[j]]).toFixed(2));
          }
        }
        chart1Data2.push({...tmpData});
        break;
    }
  }

  //chart2 정보 밀도 기준 정렬
  const chart2Data = [...item2].sort(function (a, b) {
    return b.DATA_SUM_SUM_CNT - a.DATA_SUM_SUM_CNT;
  });
  const chart2Data2 = [...item2];

  return {
    totalRdsData,
    chart1Data,
    chart1Data2,
    chart2Data,
    chart2Data2,
  };
}


export function layoutForCombination3DColumnLine({chartBaseData, areaNameAry, searchYear}) {
  const colorsStr = areaNameAry.map(areaName =>
    `<SolidColor color="${chartColor(areaName)}" />`
  ).join("");

  let layOutData =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="용도지역별 무선국 수 / 면적(㎢)"/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />'
    + '</Options>'
    + '<NumberFormatter id="numFmt" useThousandsSeparator="true" precision="0"/>'
    + '<Combination3DChart showDataTips="true" dataTipMode="single">'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis1" formatter="{numFmt}" title="' + chartBaseData.ytitle2 + '"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis1}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis2}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="AR_NAME" padding="0.5" title="' + chartBaseData.xtitle + '"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axisTitleStyleName="title"  axis="{hAxis}" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<series>'
    + '<Column3DSeries columnWidthRatio="0.6" selectable="true" yField="RDW_AREA" displayName="무선국수">'
    + '<fills>'
    + colorsStr
    + '</fills>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column3DSeries>'
    + '<Line2DSeries itemRenderer="CircleItemRenderer" radius="6" labelPosition="up" selectable="true" yField="AR_AREA" displayName="면적(㎢)" styleName="lineSeriesLabel" showValueLabels="[]">'
    + '<fills>'
    + colorsStr
    + '</fills>'
    + '<lineStroke>'
    + '<Stroke color="#f9bd03" weight="4"/>'
    + '</lineStroke>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis2" formatter="{numFmt}" title="' + chartBaseData.ytitle + '"/>'
    + '</verticalAxis>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis1}" showLine="true" axisTitleStyleName="title" />'
    + '<Axis3DRenderer axis="{vAxis2}" showLine="true" axisTitleStyleName="title" />'
    + '</verticalAxisRenderers>'
    + '</Combination3DChart>'
    + '<Style>'
    + '.lineSeriesLabel{color:#777777; fontWeight:normal;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}


export function layoutForMultiSeriesStacked({chartBaseData, areaNameAry, areaColAry, gubun_code, searchYear}) {
  let dataTipJsFunctionData = "";

  if (chartBaseData.valueFixed > 0) {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked"';
    }
  } else {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked"';
    }
  }

  var layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="지역별 무선국 밀도 (국수/㎢)"/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend  useVisibleCheck="true" defaultMouseOverAction="false"  fontSize="15" position="bottom" hAlign="center" direction="horizontal"  horizontalGap="10" itemClickJsFunction="itemClickFunc"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Column3DChart  labelPosition="inside"  showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<CategoryAxis categoryField="GUBUN_NM" id="hAxis" title="' + chartBaseData.xtitle + '" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="vAxis" title="' + chartBaseData.ytitle + '" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';

  if (chartBaseData.layOutStyle === 'Mater') {
    layOutData +=
      '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
      + '<series>'
      + '<Column3DSeries labelPosition="inside" yField="DATA_SUM" displayName="' + chartBaseData.masterName + '" styleName="seriesLabel" showValueLabels="[]">'
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Column3DSeries>'
      + '</series>'
      + '</Column3DSet>';
  } else {
    if (gubun_code === "service") {
      for (let k = 0; k < areaColAry.length; k++) {
        const areaCol = areaColAry[k];
        const areaName = areaNameAry[k];
        layOutData +=
          '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
          + '<series>'
          + '<Column3DSeries labelPosition="inside" visible="true" yField="DATA_SUM_' + areaCol + '_CNT" displayName="' + areaName + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(areaName) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '</series>'
          + '</Column3DSet>';
      }
    } else {
      for (let k = 0; k < areaColAry.length; k++) {
        const areaCol = areaColAry[k];
        const areaName = areaNameAry[k];
        layOutData +=
          '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
          + '<series>'
          + '<Column3DSeries labelPosition="inside" visible="true" yField="DATA_SUM_' + areaCol + '_CNT" displayName="' + areaName + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(areaName) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '</series>'
          + '</Column3DSet>';
      }
    }
  }
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}


// TODO: window. 제거

window.labelFunc = function (index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};

window.labelFuncNum = function (index, value) {
  return '<font size="15">' + numberWithCommas(value) + '</font>';
  return "";
};

window.itemClickFunc = function (index, displayName) {
};


export function chartColor(displayName) {
  if (displayName.indexOf('기지국') > -1) return "#41b2e6";
  else if (displayName.indexOf('간이무선국') > -1) return "#4452a8";
  else if (displayName.indexOf('육상이동국') > -1) return "#fabc05";
  else if (displayName.indexOf('이동중계국') > -1) return "#5587a2";
  else if (displayName.indexOf('이동국') > -1) return "#69cabc";
  else if (displayName.indexOf('아마추어국') > -1) return "#6c4a85";
  else if (displayName.indexOf('의무선박국') > -1) return "#8a7860";
  else if (displayName.indexOf('선박국') > -1) return "#96d4df";
  else if (displayName.indexOf('고정국') > -1) return "#f7a33b";
  else if (displayName.indexOf('전파응용설비') > -1) return "#d8c6aa";
  else if (displayName.indexOf('기타') > -1) return "#999999";
  else if (displayName.indexOf('2G LG') > -1) return "#41b2e6";
  else if (displayName.indexOf('3G LG') > -1) return "#4452a8";
  else if (displayName.indexOf('LTE LG') > -1) return "#fabc05";
  else if (displayName.indexOf('2G KT') > -1) return "#5587a2";
  else if (displayName.indexOf('3G KT') > -1) return "#69cabc";
  else if (displayName.indexOf('LTE KT') > -1) return "#6c4a85";
  else if (displayName.indexOf('2G SK') > -1) return "#8a7860";
  else if (displayName.indexOf('3G SK') > -1) return "#96d4df";
  else if (displayName.indexOf('LTE SK') > -1) return "#f7a33b";
  else if (displayName.indexOf('2G 어린이') > -1) return "#41b2e6";
  else if (displayName.indexOf('3G 어린이') > -1) return "#4452a8";
  else if (displayName.indexOf('LTE 어린이') > -1) return "#fabc05";
  else if (displayName.indexOf('2G 경제인구') > -1) return "#5587a2";
  else if (displayName.indexOf('3G 경제인구') > -1) return "#69cabc";
  else if (displayName.indexOf('LTE 경제인구') > -1) return "#6c4a85";
  else if (displayName.indexOf('2G 노년') > -1) return "#8a7860";
  else if (displayName.indexOf('3G 노년') > -1) return "#96d4df";
  else if (displayName.indexOf('LTE 노년') > -1) return "#f7a33b";
  else if (displayName.indexOf('2G') > -1) return "#41b2e6";
  else if (displayName.indexOf('3G') > -1) return "#4452a8";
  else if (displayName.indexOf('LTE') > -1) return "#fabc05";
  else if (displayName.indexOf('TBD') > -1) return "#41b2e6";
  else if (displayName.indexOf('공업지역') > -1) return "#4452a8";
  else if (displayName.indexOf('관리지역') > -1) return "#fabc05";
  else if (displayName.indexOf('녹지지역') > -1) return "#5587a2";
  else if (displayName.indexOf('농림지역') > -1) return "#69cabc";
  else if (displayName.indexOf('상업지역') > -1) return "#6c4a85";
  else if (displayName.indexOf('자연환경보전지역') > -1) return "#8a7860";
  else if (displayName.indexOf('주거지역') > -1) return "#96d4df";
  else if (displayName.indexOf('어린이') > -1) return "#20ccc1";
  else if (displayName.indexOf('경제인구') > -1) return "#5587a2";
  else if (displayName.indexOf('노년') > -1) return "#f6a44c";
  else return "#cccccc";
};


window.dataTipFunc0_Bubble = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + seriesName + "</b><br/>면적 : " + numberWithCommas(Number(values[0]).toFixed(0)) + " ㎢<br/>무선국 수 : " + numberWithCommas(Number(values[1]).toFixed(0)) + "</font>";
};

window.dataTipFunc2_Bubble = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + seriesName + "</b><br/>면적 : " + numberWithCommas(Number(values[0]).toFixed(0)) + " ㎢<br/>무선국 수 : " + numberWithCommas(Number(values[1]).toFixed(0)) + "</font>";
};

window.dataTipFunc0 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b> : " + numberWithCommas(Number(values[1])) + "</font>";

};

window.dataTipFunc2 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><font style='font-size:15px;'><b>" + values[0] + "</b> : " + numberWithCommas(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + numberWithCommas(Number(values[1])) + "</font>";

};

window.dataTipFunc2_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + numberWithCommas(Number(values[1]).toFixed(2)) + "</font>";

};

window.dataTipFunc2_Pie = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'>" + data.DATA_FIELD + " : <b>" + data.DATA_SUM_str
    + ", " + numberWithCommas(Number(values[1]).toFixed(2)) + "%</b>" + "</font>";
};
